import shortid from 'shortid';

export const WayToPayData = [
    {
      id: shortid.generate(),
      name:'04-Tarjeta de crédito'
    },
    {
      id: shortid.generate(),
      name:'28-Tarjeta de débito'
    },
    {
      id: shortid.generate() ,
      name:'03-Transferencia electrónica de fondos'
    },
    {
      id: shortid.generate() ,
      name:'02-Cheque nominativo'
    },
    {
      id: shortid.generate() ,
      name:'Depósito'
    },
    {
      id: shortid.generate() ,
      name:'01-Efectivo'
    },
    {
      id: shortid.generate() ,
      name:'99-Por definir'
    },
]




